import axios from 'axios'
import { createStore } from 'vuex'
import FctUtils from "@/components/FctUtils"
import { diagonalbackURL, defaultConfig, OctetStreamConfig, URLEncodedConfig, FormDataConfig } from "../constantes";

let currentUser=-1;
let currentClient=-1;
let currentTokenInfo = localStorage.getItem('loginUserInfos');
let usersetting = -1;
let usettings   = -1;
let currentCompteur = 0;

let parseJwt = function(token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(atob(base64));
}

function clearInfos() {
  currentTokenInfo = -1;
  currentUser = -1;
  usersetting = -1;
  usettings   = -1;
  currentCompteur = 0;
  currentClient = -1;
  localStorage.removeItem('loginUserInfos');
  localStorage.removeItem('usersetting');
  localStorage.removeItem('settings');
  localStorage.removeItem('compteur');
  localStorage.removeItem('currentClient');
}

function addBearerToConfig(token) {
  defaultConfig.headers['Authorization']="Bearer " + token;
  OctetStreamConfig.headers['Authorization']="Bearer " + token;
  URLEncodedConfig.headers['Authorization']="Bearer " + token;
  FormDataConfig.headers['Authorization']="Bearer " + token;
}

async function setExistingUser(newUserInfo) {
  try {
    var parseInfo = JSON.parse(newUserInfo);
    var exp = parseJwt(parseInfo.token).exp * 1000;

    if (exp == NaN || Date.now() >= exp) {
      clearInfos();
      return false;
    }
    else {
      //store.commit('setStatus', 'loading');

      currentTokenInfo = parseInfo;
      currentUser = 1;

      addBearerToConfig(currentTokenInfo.token);

      // On va chercher les autres infos du user dans la base
      let res = await axios(diagonalbackURL + "/users/" + currentTokenInfo.user,  defaultConfig)
      .then(reponse => {
        currentUser = reponse.data;
        store.commit('setUser', reponse.data);
        store.commit('setStatus', 'success_login');
      })
      .catch(error => {
        this.errorHandler(error);
        store.commit('setStatus', 'error_login');
      });

      return res;
    }
  } 
  catch (ex) {
    clearInfos()
  }
}


if (!currentTokenInfo) {
  clearInfos();
} 
else {
  setExistingUser(currentTokenInfo);
}


// Create a new store instance.
const store = createStore({
  mixins: [FctUtils],
  state: {
    status: '',
    currentTokenInfo:currentTokenInfo,
    /*{
      client:'',
      aud:'',
      user: '',
      role: '',
      sub:'',
      token:'' 
    },*/
    currentUser: currentUser,
    settings: usettings,
    setting: usersetting,
    modifCompteur : currentCompteur,
    currentClient : currentClient, // utilisé en SUPERADMIN, pour savoir sur quel client nous nous trouvons, car on ne peux utiliser celui du token
  },
  mutations: {
    setCompteur: function (state, mc) {
      state.modifCompteur = mc;
      localStorage.setItem('compteur', state.modifCompteur);
    },
    setStatus: function (state, status) {
      state.status = status;
    },
    setSetting: function (state, sett) {
      localStorage.setItem('usersetting', JSON.stringify(sett));
      state.setting = sett;
    },
    setSettings: function (state, setts) {
      localStorage.setItem('settings', JSON.stringify(setts));
      state.settings = setts;
    },
    setClient: function (state, clientId) {
      localStorage.setItem('currentClient', clientId);
      state.currentClient = clientId;
    },
    logCurrentUser: function (state, authData) {
      var self = this;
      var token = authData.response.data;

      // On reçoit uniquement le token JWT
      addBearerToConfig(token);
      
      // Ensuite il faut le decoder pour remplir currenUserInfos
      var infos = parseJwt(token);
      this.state.currentTokenInfo = {
        client : infos.client,
        aud    : infos.aud,
        user   : infos.user,
        role   : infos.role,
        sub    : infos.sub,
        token  : token,
      };
      // On stocke l'utilisateur courant, pour les rechagements de page
      //
      localStorage.setItem('loginUserInfos', JSON.stringify(this.state.currentTokenInfo));
    },
    setUser(state, userInfos) {
      state.currentUser = userInfos;
    },
    logout: function (state, data) {
      clearInfos()
      state.status = '';
      state.currentTokenInfo = currentTokenInfo;
      state.currentUser = currentUser;
      state.setting = '';
      state.currentClient = currentClient;
      data.router.push("/login");
    }
  },
  actions: {
    changeCompteur: ({commit, dispatch}, modif) => {
      commit('setCompteur', modif);
    },
    login: ({commit, dispatch}, userInfos) => {
      commit('setStatus', 'loading');
      return new Promise((resolve, reject) => {

        const params = JSON.stringify({
          'mail':userInfos.mail,
          'pwd':userInfos.pwd,
        });

        axios.post(diagonalbackURL + "/auth", params, defaultConfig)
        .then(function (response) {
          // Avec l'authentification, on reçoit un token de connexion
          commit('setStatus', 'success_login');
          commit('logCurrentUser', {'response':response});

          dispatch('loadCurrentUser', {'token':response.data, 'resolve':resolve});
          dispatch('loadSettings');
        })
        .catch(function (error) {
          commit('setStatus', 'error_login');
          reject(error);
        });
      });
    },
    refresh:({commit, dispatch}, userInfos) => {
      return new Promise((resolve, reject) => {
        axios.post(diagonalbackURL + "/auth/refresh", null, defaultConfig)
        .then(function(response){
          commit('logCurrentUser', { 'response':response });
          dispatch('loadCurrentUser', { 'token':response.data, 'resolve': resolve });
        })
        .catch(function (error) {
          FctUtils.methods.errorHandler(error);
        });
      });
    },
    loadCurrentUser:(context, data) => {
      // On va chercher les infos personnelles du user dans la base
      //
      axios(diagonalbackURL + "/users/" + context.state.currentTokenInfo.user,  defaultConfig)
      .then(reponse => {
        context.commit('setUser', reponse.data);

        // Renvoi dans le then du dispatch 'login' ou 'refresh'
        //
        data.resolve(data.token)
      })
      .catch(error => FctUtils.methods.errorHandler(error));
    },
    loadSettings:(context) => {

      return new Promise((resolve, reject) => {
        // On va chercher les differentes configurations possibles 
        axios(diagonalbackURL + "/clients/"+context.state.currentTokenInfo.client+"/settings",  defaultConfig)
        .then(reponse => {
          context.commit('setSettings', reponse.data);

          localStorage.setItem('settings', JSON.stringify(reponse.data));

          if (reponse.data.length == 1) {
            context.commit('setSetting', reponse.data[0]);
          }

          resolve();
        })
        .catch(error => FctUtils.methods.errorHandler(error));
      });
    },
    chooseSetting:({commit, dispatch}, setting) => {
      commit('setSetting', setting);
    },
    chooseSettings:({commit, dispatch}, settings) => {
      commit('setSettings', settings);
    },
    chooseClient:({commit, dispatch}, clientId) => {
      commit('setClient', clientId);
    },
  },
  getters: {
    status: state => state.status,
    setting: state => state.setting,
    settings: state => state.settings,
    compteur:state => state.modifCompteur,
    tokenInfo: state => state.currentTokenInfo,
    clientId: state => state.currentTokenInfo.client, // l'id du client de l'utilisateur
    userId: state => state.currentTokenInfo.user,
    currentClientId: state => state.currentClient, // l'id du client choisi / different du clientID si SUPERADMIN
    isTokenValid : function(state) {
      var result = false;
      if (state != undefined && state.currentTokenInfo != -1 && state.currentTokenInfo != undefined) {
        var exp  = parseJwt(state.currentTokenInfo.token).exp * 1000;
        var date = Date.now();

        result = !(exp == NaN || date >= exp);
      }
      return result;
    },
    isRefreshValid : function(state) {
      var result = false;
      if (state != undefined && state.currentTokenInfo != -1 && state.currentTokenInfo != undefined) {
        var exp  = parseJwt(state.currentTokenInfo.token).exp * 1000;
        var date = Date.now();
        //var date10 = new Date(date + 10*60000).getTime();
        var date10 = new Date(date + 10*60000).getTime();

        // Le token n'a pas encore expiré, s'il lui reste moins de 10 minutes de validité on le renouvelle
        result = !(exp == NaN || exp >= date10);
      }
      return result;
    }
  }
})

// init des localStorage

var us = localStorage.getItem('usersetting');

if (us != null) {
  usersetting =  JSON.parse(us);
  store.dispatch('chooseSetting', usersetting);
}


var uss = localStorage.getItem('settings');

if (uss != null) {
  usettings =  JSON.parse(uss);
  store.dispatch('chooseSettings', usettings);
}

// Compteur de Modification
currentCompteur = localStorage.getItem('compteur');
if (currentCompteur != null) {
  store.dispatch('changeCompteur', currentCompteur);
}


currentClient = localStorage.getItem('currentClient');
if (currentClient != null) {
  store.dispatch('chooseClient', currentClient);
}


export default store
